// import React from 'react'
// import { useTranslation } from 'react-i18next'
// import { useLocation, useNavigate } from 'react-router-dom'

// const OnboardingView = () => {
//   const { t } = useTranslation()
//   const location = useLocation()
//   const item = location?.state

//   const navigate = useNavigate()

//   return (
//     <div className='bg-[#F9F9F9]'>
//       <div className='px-3 py-4'>
//         <div className='bg-white border border-[#E9EDF9] rounded-lg'>
//           <div className='relative p-6 flex-auto'>
//             <div className='grid '>
//               <iframe
//                 src={
//                   `${process.env.REACT_APP_BASE_URL_FORMS}/form/` +
//                   item?.formType +
//                   '?type=admin'
//                 }
//                 height={780}
//                 title='&nbsp;'
//                 className='w-full max-h-full'
//               />
//             </div>
//           </div>
//           <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
//             <button
//               className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
//               type='button'
//               onClick={() => navigate('/forms-manager')}
//             >
//               {t('O_BACK')}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default OnboardingView


import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import apiPath from "utils/apiPath";
import { apiGet, apiPut } from "../../../utils/apiFetch";
import GridLayout from "react-grid-layout";
import useToastContext from 'hooks/useToastContext'
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "react-quill/dist/quill.snow.css";


const convertQuillClassesToInlineStyles = (htmlString) => {
  if (!htmlString) return '';
  
  const quillStyleMap = {
    'ql-align-center': 'text-align: center;',
    'ql-align-right': 'text-align: right;',
    'ql-align-left': 'text-align: left;',
    'ql-align-justify': 'text-align: justify;',
    'ql-indent-1': 'padding-left: 3em;',
    'ql-indent-2': 'padding-left: 6em;',
    'ql-indent-3': 'padding-left: 9em;',
  };

  const headingStyles = {
    h1: `
      font-size: 2rem;
      font-weight: 600;
      line-height: 1.2;
      margin: 1.5rem 0 1rem;
    `,
    h2: `
      font-size: 1.5rem;
      font-weight: 500;
      line-height: 1.1;
      margin: 1.25rem 0 0.75rem;
    `,
    h3: `
      font-size: 1.25rem;
      font-weight: 600;
      line-height: 1.35;
      margin: 1rem 0 0.5rem;
    `,
    h4: `
      font-size: 1.0rem;
      font-weight: 600;
      line-height: 1.4;
      margin: 0.75rem 0 0.5rem;
    `,
    h5: `
      font-size: 1.1rem;
      font-weight: 600;
      line-height: 1.45;
      margin: 0.5rem 0;
    `,
    h6: `
      font-size: 1rem;
      font-weight: 600;
      line-height: 1.5;
      margin: 0.5rem 0;
    `
  };

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlString;

  // Process Quill classes
  Object.entries(quillStyleMap).forEach(([className, style]) => {
    const elements = tempDiv.querySelectorAll(`.${className}`);
    elements.forEach(el => {
      const currentStyle = el.getAttribute('style') || '';
      el.setAttribute('style', `${currentStyle} ${style}`);
      el.classList.remove(className);
    });
  });

  // Apply proper heading styles
  Object.entries(headingStyles).forEach(([tag, style]) => {
    const elements = tempDiv.querySelectorAll(tag);
    elements.forEach(el => {
      const currentStyle = el.getAttribute('style') || '';
      el.setAttribute('style', `${currentStyle} ${style}`);
    });
  });

  return tempDiv.innerHTML;
};


const OnboardingView = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const notification = useToastContext();
  const { id } = location?.state || {};
  const [formData, setFormData] = useState(null);
  const [fieldValues, setFieldValues] = useState({});
  const [layouts, setLayouts] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  // Load saved layouts from localStorage
  useEffect(() => {
    if (id) {
      const savedLayouts = localStorage.getItem(`layouts-${id}`);
      if (savedLayouts) {
        setLayouts(JSON.parse(savedLayouts));
      }
      fetchFormData();
    } else {
      navigate("/forms_manager");
    }
  }, [id]);

  console.log(layouts, "layouts");

  const handleLayoutChange = (newLayout, groupIndex) => {
    setLayouts((prevLayouts) => {
      const updatedLayouts = { ...prevLayouts, [groupIndex]: newLayout };

      // Add layout data into formData.customFields
      if (formData?.customFields?.[groupIndex]) {
        const updatedFields = formData.customFields[groupIndex].map(
          (field, fieldIndex) => ({
            ...field,
            layout: {
              x: newLayout[fieldIndex]?.x ?? 0,
              y: newLayout[fieldIndex]?.y ?? 0,
              w: newLayout[fieldIndex]?.w ?? 4,
              h: newLayout[fieldIndex]?.h ?? 1,
            },
          })
        );

        const updatedFormData = { ...formData };
        updatedFormData.customFields[groupIndex] = updatedFields;
        setFormData(updatedFormData);
      }

      localStorage.setItem(`layouts-${id}`, JSON.stringify(updatedLayouts));
      return updatedLayouts;
    });
  };

  const fetchFormData = async () => {
    try {
      setIsLoading(true); // Start loading
      const res = await apiGet(`${apiPath.getFormsById}/${id}`);
      const form = res?.data?.results;

      const values = {};
      const layoutByGroup = {};

      form?.customFields?.forEach((group, groupIndex) => {
        layoutByGroup[groupIndex] = group.map((field, fieldIndex) => {
          // If field has existing layout, use that
          if (field.layout) {
            return {
              i: `${groupIndex}-${fieldIndex}`,
              x: field.layout.x,
              y: field.layout.y,
              w: field.layout.w,
              h: field.layout.h,
            };
          }

          // Default layout based on field type
          let defaultWidth = 4;
          let defaultHeight = 1;

          if (field.type === "heading") {
            defaultWidth = 12;
            defaultHeight = 2;
          } else if (field.type === "textarea") {
            defaultWidth = 12;
            defaultHeight = 4;
          } else if (field.type === "checkbox" || field.type === "radio") {
            defaultWidth = 6;
          }

          return {
            i: `${groupIndex}-${fieldIndex}`,
            x: (fieldIndex % 2) * 4, // Two columns by default
            y: Infinity, // Let it auto-position vertically
            w: defaultWidth,
            h: defaultHeight,
            static: field.type === "heading",
          };
        });

        group.forEach((field, fieldIndex) => {
          const fieldId = field?.id ?? `${groupIndex}-${fieldIndex}`;
          values[fieldId] =
            field?.value || (field?.type === "checkbox" ? [] : "");
        });
      });

      // Check if we have saved layouts in localStorage
      const savedLayouts = localStorage.getItem(`layouts-${id}`);

      // Update the formData with layouts
      const updatedFormData = { ...form };
      updatedFormData.customFields = form.customFields.map(
        (group, groupIndex) =>
          group.map((field, fieldIndex) => ({
            ...field,
            layout: savedLayouts
              ? JSON.parse(savedLayouts)[groupIndex]?.[fieldIndex] || {
                  x: layoutByGroup[groupIndex][fieldIndex].x,
                  y: layoutByGroup[groupIndex][fieldIndex].y,
                  w: layoutByGroup[groupIndex][fieldIndex].w,
                  h: layoutByGroup[groupIndex][fieldIndex].h,
                }
              : {
                  x: layoutByGroup[groupIndex][fieldIndex].x,
                  y: layoutByGroup[groupIndex][fieldIndex].y,
                  w: layoutByGroup[groupIndex][fieldIndex].w,
                  h: layoutByGroup[groupIndex][fieldIndex].h,
                },
          }))
      );

      // Set all states together to prevent inconsistent renders
      setFormData(updatedFormData);
      setFieldValues(values);
      setLayouts(savedLayouts ? JSON.parse(savedLayouts) : layoutByGroup);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false); // End loading
    }
  };

  console.log(formData, "formData");

  const handleChange = (e, fieldId, type) => {
    const { value, checked, files } = e.target;

    setFieldValues((prev) => {
      if (type === "checkbox") {
        const current = prev[fieldId] || [];
        return {
          ...prev,
          [fieldId]: checked
            ? [...current, value]
            : current.filter((v) => v !== value),
        };
      }

      if (type === "file") {
        return { ...prev, [fieldId]: files[0] };
      }

      return { ...prev, [fieldId]: value };
    });
  };


  const renderField = (field, groupIndex, fieldIndex) => {
    const fieldId = field?.id ?? `${groupIndex}-${fieldIndex}`;
    const value = fieldValues[fieldId] ?? "";
    const { type, label, options, placeholder, mandatory, styles} = field;

    const labelStyle = "min-w-max text-xs whitespace-nowrap mr-[5px]";
    const inputStyle = "flex-1 border px-3 py-2 bg-gray-200 text-xs";

    console.log(mandatory, "mandatory");

    switch (type) {
      case "heading": {
        let headingText, subheadingText;

        if (typeof value === "string") {
          // For comma-separated string format
          [headingText, subheadingText] = (value || "")
            .split(",")
            .map((s) => s.trim());
        } else if (typeof value === "object" && value !== null) {
          // For object format {heading: "...", subheading: "..."}
          headingText = value.heading || "";
          subheadingText = value.subheading || "";
        } else {
          headingText = "";
          subheadingText = "";
        }

        return (
          <div
            key={fieldId}
            className="mb-4 p-4 bg-[#E1E1E1] w-full rounded text-center text-gray-700"
          >
            <h2 className="text-lg font-semibold mb-2">{headingText}</h2>
            {subheadingText && <p className="text-lg">{subheadingText}</p>}
          </div>
        );
      }
      case "input":
      case "select":
      case "date":
        return (
          <div className="mb-4 flex items-center gap-1" key={fieldId}>
            <label className={`text-xs ${labelStyle}`}>
              {label}{" "}
              {mandatory && <span className="text-red-500 ml-1">*</span>}
            </label>
            {type === "input" && (
              <input
                type="text"
                className={inputStyle}
                value={value}
                onChange={(e) => handleChange(e, fieldId, type)}
                placeholder={placeholder}
                disabled  
              />
            )}
            {type === "date" && (
              <input
                type="date"
                className={`${inputStyle || ''} non-draggable`}
                value={value}
                onChange={(e) => handleChange(e, fieldId, type)}
                disabled  
              />
            )}
            {type === "select" && (
              <select
                className={inputStyle}
                value={value}
                onChange={(e) => handleChange(e, fieldId, type)}
                disabled  
              >
                <option value="">Select</option>
                {options?.map((opt, idx) => (
                  <option key={idx} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            )}
          </div>
        );
      case "textarea":
        return (
          <div className="mb-4" key={fieldId} style={{ clear: "both" }}>
            <div
              className="whitespace-pre-wrap  px-3 py-2 mb-10 rounded "
              style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
            >
              {value || "No content"}
            </div>
          </div>
        );
        case "textEditor":
          // Convert Quill classes to inline styles
          const convertedHtml = convertQuillClassesToInlineStyles(value);
          
          return (
            <div className="mb-4" key={fieldId} style={{ clear: "both" }}>
              <label className={`text-sm ${labelStyle}`}>
               
                {mandatory && <span className="text-red-500 ml-1">*</span>}
              </label>
              <div
                className="px-3 py-2 mb-10 rounded border bg-white"
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  minHeight: "100px",
                  overflow: "auto"
                }}
                dangerouslySetInnerHTML={{ __html: convertedHtml }}
              />
            </div>
          );

      case "radio":
        return (
          <div className={styles.optionsContainer} key={fieldId}>
            <label className="block mb-1 font-bold">
              {label}{" "}
              {mandatory && <span className="text-red-500 ml-1">*</span>}
            </label>
            <div className=" non-draggable flex gap-4 flex-wrap">
              {options?.map((opt, idx) => (
                <label key={idx} className="non-draggable flex items-center gap-2 ">
                  <input
                    type="radio"
                    name={fieldId}
                    className="non-draggable"
                    value={opt}
                    checked={value === opt}
                    onChange={(e) => handleChange(e, fieldId, type)}
                    disabled  
                  />
                  {opt}
                </label>
              ))}
            </div>
          </div>
        );
      case "checkbox":
        return (
          <div className={styles.optionsContainer} key={fieldId}>
            <label className="block mb-1 font-bold">
              {label}{" "}
              {mandatory && <span className="text-red-500 ml-1">*</span>}
            </label>
            <div className="flex gap-4 flex-wrap">
              {options?.map((opt, idx) => (
                <label key={idx} className="non-draggable flex items-center gap-2">
                  <input
                    type="checkbox"
                    name={`${fieldId}-${opt}`}
                    value={opt}
                    checked={(value || []).includes(opt)}
                    onChange={(e) => handleChange(e, fieldId, type)}
                    disabled  
                  />
                  {opt}
                </label>
              ))}
            </div>
          </div>
        );
      case "file":
        return (
          <div className="mb-4" key={fieldId}>
            <label className="block mb-1">
              {label}{" "}
              {mandatory && <span className="text-red-500 ml-1">*</span>}
            </label>
            {value ? (
              <img
                src={value}
                alt="Uploaded image"
                className="max-w-xs h-auto rounded border"
              />
            ) : (
              <p className="text-gray-500 text-sm">No file uploaded</p>
            )}
          </div>
        );
      case "html":
        return (
          <div
            key={fieldId}
            className="mb-4"
            dangerouslySetInnerHTML={{ __html: label }}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="bg-[#F9F9F9]">
      <div className="py-4 px-3">
        <div className="bg-white border border-[#E9EDF9] rounded-lg">
          <div className="p-6">
            {formData?.customFields?.map((group, groupIndex) => (
              <GridLayout
                key={groupIndex}
                className="layout mb-8"
                cols={12}
                // rowHeight={30}
                rowHeight={20} // Optionally reduce height too
                margin={[8, 4]}
                style={{ fontSize: "12px" }}
                width={1000}
                layout={layouts[groupIndex]}
                draggableCancel=".non-draggable, .ql-toolbar, .ql-container"
                isDraggable={false}
                isResizable = {false}
                onLayoutChange={(newLayout) =>
                  handleLayoutChange(newLayout, groupIndex)
                }
              >
                {group.map((field, fieldIndex) => (
                  <div
                    key={`${groupIndex}-${fieldIndex}`}
                    data-grid={
                      layouts[groupIndex]?.[fieldIndex] ?? {
                        i: `${groupIndex}-${fieldIndex}`,
                        x: 0,
                        y: 0,
                        w: 4,
                        h: 1,
                      }
                    }
                  >
                    {renderField(field, groupIndex, fieldIndex)}
                  </div>
                ))}
              </GridLayout>
            ))}

            <div className="border-t pt-4 flex justify-center">
              <button
                onClick={() => navigate("/forms_manager")}
                className="bg-[#E1E1E1] px-12 py-2.5 rounded text-sm text-black"
              >
                {t("O_BACK")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingView;